import { graphql } from "~/gql";

export const PHASE_FRAGMENT = graphql(/* GraphQL */ `
  fragment PhaseParts on Phase {
    __typename
    autoFocus @client
    id
    title
    html
    description
    order
    createdAt
    updatedAt
    matterId
    markedComplete
    completionPercentage
    startDate
    deadlineDate
    priceOptions {
      ...PriceOptionsParts
    }
    tasks {
      ...TaskParts
    }
    work {
      ...WorkParts
    }
  }
`);
